var loggerService = function () {
    var oldConsoleLog = null;
    var oldConsoleDebug = null;
    var pub = {};

    pub.enableLogger = function enableLogger() {
        if (oldConsoleLog == null)
            return;

        window['console']['log'] = oldConsoleLog;
        window['console']['debug'] = oldConsoleDebug;
    };

    pub.overrideLogger = function overrideLogger(newLogger) {
        window['console']['log'] = newLogger.log;
        window['console']['debug'] = newLogger.debug;
    };

    pub.disableLogger = function disableLogger() {
        oldConsoleLog = console.log;
        oldConsoleDebug = console.debug;
        window['console']['log'] = function () { };
        window['console']['debug'] = function () { };
    };

    return pub;
}();

$(document).ready(function () {
    loggerService.disableLogger();
    var consoleEnabled = window.siteSettings.consoleEnabled;
    if (consoleEnabled !== "false") {
        loggerService.enableLogger();
        if (Logger) {
            Logger.useDefaults({
                defaultLevel: Logger.DEBUG,
                formatter: function (messages, context) {
                    messages.unshift(new Date().toUTCString());
                }
            });
            loggerService.overrideLogger(Logger);
        }

        console.log("logging is enabled!");
    }
});